module.exports = __webpack_public_path__ + "img/P64-zh.c031c936.png";